/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Carrier_Checking_ShippeekInputs */

const en_orders_carrier_checking_shippeek = /** @type {(inputs: Orders_Carrier_Checking_ShippeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Checking ShipPeek rates. Please wait a moment.`)
};

const es_orders_carrier_checking_shippeek = /** @type {(inputs: Orders_Carrier_Checking_ShippeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revisando tarifas de ShipPeek. Espera un momento.`)
};

/**
* | output |
* | --- |
* | "Checking ShipPeek rates. Please wait a moment." |
*
* @param {Orders_Carrier_Checking_ShippeekInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_carrier_checking_shippeek = /** @type {((inputs?: Orders_Carrier_Checking_ShippeekInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Carrier_Checking_ShippeekInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_carrier_checking_shippeek(inputs)
	return es_orders_carrier_checking_shippeek(inputs)
});